<!--
 * @Author: your name
 * @Date: 2021-07-14 19:42:47
 * @LastEditTime: 2022-11-08 14:30:51
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \xadc\src\views\PersonalCenter\detail.vue
-->
<template>
  <div class="detail">
    <div class="label">
      <div class="title">账号信息</div>
      <div class="btn" @click="infoEdit=!infoEdit">编辑</div>
    </div>
    <van-cell-group class="cell-list" v-if="!infoEdit">
      <van-cell title="登录名" :value="userFullInfo.loginName" title-class="cell-title" value-class="cell-value" />
      <van-cell title="账号状态" 
        :value="getYHZT(userFullInfo.YHZT)" 
        title-class="cell-title adopt" 
        :value-class="{
          'account-wait': userFullInfo.YHZT == '0' || userFullInfo.YHZT == '4',
          'account-passed': userFullInfo.YHZT == '1',
          'account-warning': userFullInfo.YHZT == '2' || userFullInfo.YHZT == '3',
        }"
      />
      <van-cell title="账号类型" :value="userFullInfo.accountType" title-class="cell-title" value-class="cell-value" required/>
      <van-cell title="证件类型" :value="getZJLX(userFullInfo.ZJLX)" title-class="cell-title" value-class="cell-value" required/>
      <van-cell title="联系人" :value="userFullInfo.LXR" title-class="cell-title" value-class="cell-value" requ ired/>
      <van-cell title="证件号码" :value="userFullInfo.ZJHM" title-class="cell-title" value-class="cell-value" required/>
      <van-cell title="单位地址" :value="userFullInfo.DWDZ" title-class="cell-title" value-class="cell-value" v-if="userFullInfo.accountType == '企业'" required/>
      <van-cell title="单位名称" :value="userFullInfo.DWMC" title-class="cell-title" value-class="cell-value" v-if="userFullInfo.accountType == '企业'" required/>
      <van-cell title="法人名称" :value="userFullInfo.FRMC" title-class="cell-title" value-class="cell-value" v-if="userFullInfo.accountType == '企业'" required/>
      <van-cell title="法人身份证" :value="userFullInfo.FRSFZH" title-class="cell-title" value-class="cell-value" v-if="userFullInfo.accountType == '企业'" required/>
      <van-cell title="手机号码" :value="userFullInfo.mobilePhone" title-class="cell-title" value-class="cell-value" required/>
    </van-cell-group>
    <van-form @submit="onSubmit" class="line-form" v-if="infoEdit" ref="formData">
      <van-field v-model="fromData.loginName" class="disabled"
        label="登录名" placeholder="请输入登录名" readonly
        :rules="[{ required: true, message: '请填写登录名' }]"
      />
      <van-field v-model="fromData.YHZT" label="账号状态" class="disabled" readonly/>
      <van-field
        readonly
        clickable
        name="picker0"
        :value="fromData.accountType"
        label="账号类型"
        placeholder="点击选择账号类型"
        @click.stop="openAccountType"
        required
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="getZJLX(fromData.certType)"
        label="证件类型"
        placeholder="点击选择证件类型"
        @click.stop="openCertPicker"
        required
      />
      <van-field v-model="fromData.LXR" label="联系人" clearable placeholder="请输入联系人" required />
      <van-field v-model="fromData.ZJHM" label="证件号码" clearable placeholder="请输入证件号码" required/>
      <van-field v-model="fromData.DWDZ"
        label="单位地址" placeholder="请输入单位地址" required clearable
        :rules="[{ required: true, message: '请填写单位地址' }]"
        v-if="fromData.accountType == '企业'"
      />
      <van-field v-model="fromData.DWMC"
        label="单位名称" placeholder="请输入单位名称" required clearable
        :rules="[{ required: true, message: '请填写单位名称' }]"
        v-if="fromData.accountType == '企业'"
      />
      <van-field 
        v-model="fromData.FRMC"
        label="法人名称" 
        placeholder="请输入法人名称" 
        required 
        clearable
        :rules="[{ required: true, message: '请填写法人名称' }]"
        v-if="fromData.accountType == '企业'"
      />
      <van-field 
        v-model="fromData.FRSFZH"
        label="法人身份证"
        placeholder="请输入法人身份证" 
        required 
        clearable
        :rules="[{ required: true, message: '请填写法人身份证' }]"
        v-if="fromData.accountType == '企业'"
      />
      <van-field v-model="fromData.mobilePhone"
        label="手机号码" placeholder="请输入手机号码" required readonly class="disabled" clearable
        :rules="[{ required: true, message: '请填写手机号码' }]"
      >
        <template #button>
          <van-button size="small" type="info" plain @click.stop="updateMobile">更换手机号码</van-button>
        </template>
      </van-field>
      <van-field v-model="fromData.validate"
        label="获取验证码" placeholder="请输入获取验证码" clearable center
        :rules="[{ required: isVerifyCode, message: '请填写验证码' }]"
      >
        <template #button>
          <van-button plain type="info" native-type="button" size="small" class="code-btn" @click.stop="getSMSCode">
            {{ numCount == 60 ? '获取验证码' : `${numCount}s` }}
          </van-button>
        </template>
      </van-field>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="accountTypeArr" @confirm="confirmAccountType" @cancel="showPicker=false" v-if="popupType == 'accountType'"/>
      <van-picker show-toolbar :columns="certificateArr" value-key="showValue" @confirm="confirmCertification" @cancel="showPicker=false" v-if="popupType == 'certification'"/>
    </van-popup>
    <div class="label">
      <div class="title">附件材料列表</div>
      <div class="btn" @click="infoEdit=!infoEdit">编辑</div>
    </div>
    <div class="file-list">
      <div class="file-panel" v-for="(item,index) in fromData.ZJFJ" :key="index">
        <account-file-upload
          :title="item.ZLMC"
          v-model="item.FJLIST"
          :serialNo="index + 1"
          :content="item.ZLSM"
          :isCheck="item.SFBX == '是'"
          :isEdit="infoEdit"
        ></account-file-upload>
      </div>
    </div>
    <div class="btn-group" v-if="infoEdit">
      <!-- <van-button round block type="info" class="submit-btn" native-type="submit">保存</van-button> -->
      <van-button class="btn-save submit-btn" block type="info" @click.stop="onSubmit">保存</van-button>
    </div>
  </div>
</template>
<script>
//  常量声明
//  引入外部资源
import AccountFileUpload from "@/components/PersonalCenter/account-file-upload.vue";
import api from '@/utils/api/personCenter'
import commonApi from '@/utils/api/common.js'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  name: 'Detail',
  mixins: [ moduleMixins ],
  components: { AccountFileUpload },
  props: {},
  data() {
    return {
      //  状态
      flag: true,
      //  变量
      list: [],
      fileInfo:{},// 附件材料信息
      fileList:[],// 附件材料列表
      userInfo: {},// 用户信息
      userFullInfo:{},// 用户完整信息
      infoEdit: false,// 是否允许编辑
      fileEdit: false,
      fromData: {
        loginName: '',// 登录名
        YHZT:'',// 账号（审核）状态
        accountType:'',// 账号类型
        certType:'',// 证件类型
        LXR:'',// 联系人
        ZJHM:'',// 证件号码
        DWDZ:'',// 单位地址
        DWMC: '',// 单位名称
        FRMC:'',// 法人名称
        FRSFZH: '',// 法人身份证号
        mobilePhone: '',// 手机号码
        validate: '',// 验证码
        ZJFJ:{}// 证件附件
      },
      certValue: '',
      accountTypeArr: ['个人', '企业'],// 账号类型
      certColumns: ['身份证', '统一社会信用代码', '港澳台通行证'],// 证件类型
      accountStatusArr:[
        {
          value:0,
          color:'#FFA403',
          text:'未审核',
        },
        {
          value:1,
          color:'#0BDE78',
          text:'审核通过',
        },
        {
          value:2,
          color:'red',
          text:'审核不通过',
        },
        {
          value:3,
          color:'red',
          text:'禁用',
        },
        {
          value:4,
          color:'#FFA403',
          text:'完善信息',
        },
      ],// 审核状态数组
      certificateArr:[],// 证件类型键值对
      popupType:"",// 选择器类型
      showPicker: false,// 显示选择器
      isVerifyCode: false,// 是否需要验证码授权修改，默认false
      numCount: 60,// 倒计时60s
      ZJFJIndex: 0,//
    }
  },
   computed: {
    navTitle() {
      return '账号信息'
    }
  },
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    // 账号类型选择器确认
    confirmAccountType(value) {
      this.fromData.accountType = value;
      this.showPicker = false;
    },
    // 证件类型选择器确认
    confirmCertification(value) {
      // value.showValue 证件类型名称 
      this.fromData.certType = value.code;// 证件类型代码
      this.showPicker = false;
    },
    // 账号类型选择器
    openAccountType(){
      this.popupType = 'accountType';
      this.showPicker = true
    },
    // 证件类型选择器
    openCertPicker(){
      this.popupType = 'certification';
      this.showPicker = true
    },
    // 获取账号状态
    getYHZT(val){
      console.log('getYHZT:',val);
      let accountStatusArr = this.accountStatusArr
      for(let i = 0; i < accountStatusArr.length; i++){
        if(String(accountStatusArr[i].value) == String(val)){
          return accountStatusArr[i].text 
        }
      }
    },
    // 获取证件类型
    getZJLX(val){
      // 获取证件类型对应的key,value
      // console.log("this.certificateArr:",this.certificateArr);
      let certificateArr = this.certificateArr
      for(let i = 0; i < certificateArr.length; i++){
        if(String(certificateArr[i].code) == String(val)){
          return certificateArr[i].showValue 
        }
      }
    },
    // 获取短信验证码
    getSMSCode() {
      if(this.numCount != 60 ) {
        this.$toast('不允许频繁请求')
        return
      }
      if(!this.fromData.mobilePhone) {
        this.$toast('请输入手机号')
        return
      }
      api.sendVerification({
        mobileNo: this.fromData.mobilePhone
      }).then(() => {
        this.$toast('短信发送成功')
        let timer = setInterval(()=> {
          this.numCount--
          if(this.numCount <= 0) {
            clearInterval(timer)
            this.numCount = 60
          }
        }, 1000)
      })
    },
    // 修改手机号码
    updateMobile(){
      // 跳转个人中心账户安全模块
      this.$router.push({
        name: 'PersonalCenterSecurity'
      })
    },
    // 获取账号修改是否需要验证码
    getPersonConfig(){
      let params = {}
      api
        .getPersonConfig(params)
        .then(res => {
          console.log("getPersonConfig:",res)
          this.isVerifyCode = res.data.isHaveVerifyWhenModify == '1' ? true : false// true需要验证码，false不需要
        })
        .catch(err => {
          console.log("err:",err.response);
        })
    },
    // 提交修改
    onSubmit() {
      // this.$refs.formData.submit();// 执行van-form表单验证
      let params = {}
      params.accountType = this.fromData.accountType// 账户类型
      params.loginName = this.fromData.loginName// 登陆名
      params.LXR = this.fromData.LXR// 联系人
      params.idType = this.fromData.certType// 证件类型

      params.idNumber = this.fromData.ZJHM// 证件号码
      params.DWMC = this.fromData.DWMC// 单位名称
      params.DWDZ = this.fromData.DWDZ// 单位地址
      params.FRMC = this.fromData.FRMC// 法人名称

      params.FRSFZH = this.fromData.FRSFZH// 法人身份证
      params.ZJFJ = this.fromData.ZJFJ// 附件材料列表
      params.validate = this.fromData.validate// 账户类型

      // console.log("onSubmit params:",params);
      api
        .updateUserInfo(params)
        .then(res => {
          console.log("updateUserInfo:",res)
          if(res.code == 0){
            this.$toast.success('修改成功')
            this.infoEdit = false
            this.getData()
          }
          // if(res.code == 500){
          //   this.$toast.fail(res.message)
          // }
        })
        .catch(err => {
          // console.log("err:",err.response);
          this.$toast(err.response.data.message)
        })
    },
    login(){
      this.$router.push({
        name: 'Login'
      })
    },
    getData() {
      this.info = this.$store.state.userInfo
      this.flag = this.info ? false : true
      let params = {}
      // 获取用户完整信息
      api
        .getLoginUserInfo(params)
        .then(res => {
          console.log(res)
          this.userFullInfo = res.data
          this.$store.commit('setFullUserInfo', res.data)
        })
        .catch(err => {
          console.log(err.response)
          this.$dialog.confirm({
            title: '—— 温馨提示 ——',
            message: err.response.data.message,
            confirmButtonText: '去登录',
            confirmButtonColor: '#1D84FF'
          })
          .then(() => {
            this.logIn()
          }).catch(() => {
            // on cancel
          });
        })
    },
    // 上传文件
    submitFile(item,index){
      this.ZJFJIndex = index// 获取上传附件的属于哪种文件的索引
    },
    // 修改/完善信息
    loadData(){
      let vm = this
      this.fromData.loginName = this.userFullInfo.loginName// 登录名
      this.fromData.YHZT = this.getYHZT(vm.userFullInfo.YHZT)// 账号（审核）状态
      this.fromData.accountType = this.userFullInfo.accountType// 账号类型
      this.fromData.certType = vm.userFullInfo.ZJLX// 证件类型 

      this.fromData.LXR = this.userFullInfo.LXR// 联系人
      this.fromData.ZJHM = this.userFullInfo.ZJHM// 证件号码
      this.fromData.DWDZ = this.userFullInfo.DWDZ// 单位地址
      this.fromData.DWMC = this.userFullInfo.DWMC// 单位名称

      this.fromData.FRMC = this.userFullInfo.FRMC// 法人名称
      this.fromData.FRSFZH = this.userFullInfo.FRSFZH// 法人身份证号
      this.fromData.mobilePhone = this.userFullInfo.mobilePhone// 手机号码

      this.fromData.ZJFJ = this.userFullInfo.ZJFJ.rowsList// 材料列表
      // for(let i = 0; i < ZJFJ.rowsList.length; i++){

      // }
    },

    onAfterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (!(file instanceof Array)) {
        this.upload(file)
      } else {
        file.forEach(item => {
          this.upload(item)
        })
      }
      this.$emit('onAfterRead', file)
    },
    // 文件读取前的回调函数
    onBeforeRead(file) {
      console.log('onBeforeRead:',file)
      // 黑名单文件判断(固定9种类型)
      if (/.(jsp|jspx|jspf|sh|html|htm|shtml|js|htaccess)$/i.test(file.name)) {
        this.$toast('文件类型不支持')
        return false
      }
      // 文件类型判断(由后台配置传入)
      if (this.accept && this.accept != '*') {
        const nameArr = file.name.split('.')
        const type = '.' + nameArr[nameArr.length - 1]
        if (!this.accept.includes(type)) {
          this.$toast('文件类型不匹配')
          return false
        }
      }
      this.fileName = file.name// 附件名称
      this.titleName = this.getTitleName(file)// CLMC材料名称（可手动编辑）
      this.$emit('onBeforeRead', file)
      return true
    },
    upload(file) {
      const params = new FormData()
      console.log('file', file)
      params.append('file', file.file)
      api
        .materialUpload(params)
        .then(res => {
          console.log("upload res:",res);
          if(res.code == 0){
            // this.fileList.push(res.data[0])
            let data = res.data[0]
            let obj = {}
            // this.fileName = data[i].fileName// 附件名称
            // this.titleName = this.getTitleName(data[i].fileName)// CLMC材料名称（可手动编辑）
            obj.FJNAME = data.fileName// 附件名称
            obj.FJURL = data.fileUrl// 附件文件服务器路径
            // debugger
            for(let i = 0; i < this.fromData.ZJFJ.length; i++){
              console.log("this.fromData.ZJFJ:",this.fromData.ZJFJ);
              console.log("this.ZJFJIndex:",this.ZJFJIndex);

              if(this.ZJFJIndex == i){
                console.log("this.fromData.ZJFJ[i].FJLIST:",this.fromData.ZJFJ[i].FJLIST);
                this.fromData.ZJFJ[i].FJLIST = this.fromData.ZJFJ[i].FJLIST.concat(obj)
              }
            }
            // this.fromData.ZJFJ = this.fromData.ZJFJ.concat(obj)
            this.$toast.success("材料上传成功")
          }
        })
        .catch(err => {
          console.log("err:",err.response);
          // this.$toast.fail('材料上传失败')
        })
    },
    // 删除附件
    deleteFile(item, i) {
      console.log("deleteFile item:",item,"i:",i);
      // this.list.splice(i, 1);
      // this.listValue.splice(i,1)
      // this.$emit("input", this.listValue);
    },
    // 下载附件
    downloadFile(item,i){
      console.log("downloadFile item:",item,"i:",i);
    },
    // 获取文件名
    getTitleName(file){
      return file.name.substring(0, file.name.lastIndexOf("."));
    },
    // 计算文件大小
    getSize(fileSize) {
      let size = ''
      if (fileSize < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = fileSize.toFixed(2) + 'B'
      } else if (fileSize < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (fileSize / 1024).toFixed(2) + 'KB'
      } else if (fileSize < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (fileSize / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        // 其他转化成GB
        size = (fileSize / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }

      const sizeStr = size + '' // 转成字符串
      const index = sizeStr.indexOf('.') // 获取小数点处的索引
      const dou = sizeStr.substr(index + 1, 2) // 获取小数点后两位的值
      if (dou == '00') {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size
    },
  
    // 加载指定字典
    loadDict(val) {
      //先要判断vuex有没有保存字典
      if (Object.keys(this.$store.state.projectCode).length == 0) {
        commonApi.lookupDict({code: val}).then(res => {
          console.log('loadDict --res: ', res)
          this.certificateArr = res.data
        })
      }
    }
  },
  filters: {
    getUploadText(val){// 获取附件材料是否已经上传
      let upLoadText = '';
      if(val == '是'){
        upLoadText = '已上传';
      }else {
        upLoadText = '未上传';
      }
      return upLoadText;
    },
   
  },
  created() {},
  async mounted() {
    this.userInfo = this.$store.state.userInfo ? this.$store.state.userInfo : ''
    this.userFullInfo =  this.$store.state.userFullInfo ? this.$store.state.userFullInfo : ''
    this.fileInfo = this.userFullInfo.ZJFJ
    this.fileList = this.userFullInfo.ZJFJ ? this.userFullInfo.ZJFJ.rowsList : []
    // console.log("this.userInfo :",this.userInfo )
    await this.loadDict('ZJLX');// 获取证件类型
    this.getPersonConfig()// 是否需要验证码修改
    this.getData()
    this.loadData()
  },
  destoryed() {}
}
</script>
<style lang="scss" scoped>
.detail {
  font-family: PingFang SC;
  font-size: 15px;
  padding-bottom: 50px;
  .label {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    .btn {
      color: #1d84ff;
    }
  }
  .cell-list {
    .van-cell__value {
      -webkit-box-flex: 2;
      -webkit-flex: 2;
      flex: 2;
    }
    .cell-title {
      font-weight: 500;
      color: #333333;
      line-height: 2;
    }
    // .adopt {
    //   & + .van-cell__value {
    //     color: #0BDE78;
    //   }
    // }
    
    .account-passed{
      color: #52c41a;
    }
    .account-wait {
      color: #FFA403;
    }
    .account-warning{
      color: red;
    }
    .cell-value {
      font-weight: 500;
      color: #999999;
      line-height: 2;
    }
  }
  .line-form {
    padding: 15px;
    background-color: #fff;
    ::v-deep .van-cell {
      display: block;
      .van-field__label {
        width: 100%;
        padding-bottom: 5px;
      }
      .van-field__value .van-field__body {
        padding: 5px 10px;
        border: 1px solid #ddd;
      }
      &::after {
        border-bottom: 0;
      }
    }
    .disabled {
      ::v-deep .van-field__value .van-field__body {
        background-color: #F1F3F6;
        border: 1px solid #ddd;
      }
    }
  }

  .file-list {
    background-color: #fff;
    padding: 15px;
    padding-bottom: 50px;
    .file-panel{
      margin-bottom: 10vw;
    }
    .appoint-title{
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 10px;
      display: flex;
      flex: 1;
    }
    .isneed-file{
      height: 8vw;
    }
    .file-item {
      padding: 10px;
      margin-bottom: 10px;
      border-radius: 3px;
      border: 1px solid #666;
      display: flex;
      min-height: 6vw;
      // height: 6vw;
      justify-content: space-between;
      align-items: center;

      .name {
        color: #1d84ff;
      }
      .desc {
        font-size: 14px;
      }
      .btn-upload{
        font-weight: 500;
        color: #1D84FF;
        // height: 6vw;
        .arae-upload{
          display: flex;
          align-items: center;
          justify-content: center;
          .icon-fujian{
            width: 4vw;
            height: 4vw;
          }
          .fj-upload-text{
            font-size: 14px;
            font-weight: 500;
            color: #1D84FF;
          }
        }
      
      }
    }
    .not {
      border: 1px solid #ddd;
      color: #DDDDDD;
      .name {
        color: #999;
      }
    }
  }
  .btn-group {
    margin: 50px 20px;
    .btn-save{
      background: #1D84FF;
      border-radius: 5px;
    }
  }
}


</style>